<template>
  <div class="header variant-2h"><!-- variant-2h -->

    <!-- col-1 start -->
    <div class="col-1">
      <img src="../assets/images/banner-1.svg" alt="">
    </div>
    <!-- col-1 stop -->

    <!-- col-2 start -->
    <div class="col-2">
      <form>

        <!-- hb2 start -->
        <div class="hb2">
          <div class="user">
            <img src="../assets/images/user.svg" alt="" />:
           <span> {{$store.state.user.User}}</span>
          </div>
          <div class="business-and-finance">
          <img src="../assets/images/business-and-finance.png" alt="" />
          <span>{{profit()}}</span>
          </div>
          <div class="dollar">
            <img src="../assets/images/dollar.svg" alt="" />
            <span>{{$store.state.user.Currency}}</span>
          </div>
        </div>
        <!-- hb2 stop -->

        <!-- selectCurrency start -->
        <div class="selectCurrency">
          <select class="selectpicker show-tick">
            <option selected="selected">Currency</option>
            <option>Currency 1</option>
            <option>Currency 2</option>
            <option>Currency 3</option>
          </select>
        </div>
        <!-- selectCurrency stop -->

      </form>
    </div>
    <!-- col-2 stop -->

    <!-- language start -->
    <div class="language">
      <div><img src="@/assets/images/ru.svg" alt="" @click="$i18n.locale = 'ru'; cookies.set('lang', 'ru', { expires: 30 })"></div>
      <div><img src="@/assets/images/gb.svg" alt="" @click="$i18n.locale = 'en'; cookies.set('lang', 'en', { expires: 30 })"></div>
    </div>
    <!-- language stop -->

    <!-- row-5top start -->
    <div class="row-5top">
        <div @click="$router.push({name: 'report'})"><img src="@/assets/images/notes.svg" alt="" /></div>
        <div @click="$router.push({name: 'statistics'})"><img src="@/assets/images/keys.svg" alt="" /></div>
        <!--<div @click=""><img src="@/assets/images/detailed.svg" alt="" /></div>-->
        <div @click="tv()" @contextmenu.prevent="rightclick()"><img src="@/assets/images/tv.svg" alt="" /></div>
        <div @click="logout()"><img src="@/assets/images/power-button.svg" alt="" /></div>
      </div>
    <!-- row-5top stop -->

  </div>
  <!-- header variant 2h STOP -->
</template>

<script>
import axios from 'axios'
import Cookies from 'js-cookie'

export default {
  name: 'Stats',
  data: function(){
    return {
      lang: 'en'
    }
  },
 
  computed: {
    /*game: function(){
        var game = { time: {min: '', sec: ''}, count: ''};
        game.time.min = Math.floor(this.$store.state.game.Time / 60);
        game.time.sec = this.$store.state.game.Time - game.time.min * 60;
        game.count = this.$store.state.game.Time;
        return game;
    }*/
  },
  methods: {
    profit(){
      if(!this.$store.state.usersreport) return 0
      let result = 0;
      let outcome = 0;
      for(let i = 0; i < this.$store.state.usersreport.tickets.length; i++){
        result += this.$store.state.usersreport.tickets[i].Bets.map(item => item.Amount).reduce((prev, next) => prev + next);

        if(this.$store.state.usersreport.tickets[i].Type == "Single"){
          outcome += this.$store.state.usersreport.tickets[i].Bets.map(item => item.Winnings).reduce((prev, next) => prev + next);
        }else{
          if(this.$store.state.usersreport.tickets[i].State == "Payed"){
            outcome += this.$store.state.usersreport.tickets[i].Amount * this.$store.state.usersreport.tickets[i].Bets.map(item => item.Coefficient).reduce((prev, next) => prev * next);
          }
        }
      }
      result = result - outcome
      return result.toFixed(2)
    },
    countDownTimer() {
        if(this.game.Time > 0) {
            setTimeout(() => {
                this.game.time -= 1
                this.countDownTimer()
            }, 1000)
        }else{
          this.$store.dispatch('apirequest', {token: this.$sotre.state.user.token, name: "game/"});
        }
    },
    tv(){
      let routeData = this.$router.resolve({name: 'TV', params: {Token: this.$store.state.user.token}});
      return window.open(routeData.href, "", "width="+window.screen.width+",height="+window.screen.height);
    },
    rightclick(){
      let routeData = this.$router.resolve({name: 'TV', params: {Token: this.$store.state.user.token}});
      return window.open(routeData.href);
    },
   logout(){
      this.$store.dispatch('logout');
      this.$router.push({name: 'auth'});
    },
    
  },
  watch: {
    game: function(){
      
    }
  }
};
</script>-->
